 
 
 
 
 
 
define(['leaflet', './addressContainer'], function(L, addressContainer) {
    'use strict';
    return function(data) {
        var div = L.DomUtil.create('div', 'tomtom-point-content__address');

        if (data.address) {
            div.appendChild(addressContainer(data.address));
        } else {
            data.getAddress().then(function(data) {
                div.appendChild(addressContainer(data.address));
            });
        }
        return div;
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/details/addressContent.js